import { RootState } from 'app/store';
import { createSelector } from 'reselect';
import { FilterType } from '../campaign.type';
import { notificationAdapter } from './notification.adapter';

export const {
  selectAll: selectCampaigns,
  selectById: selectCampaignById,
  selectIds: selectCampaignsIds,
} = notificationAdapter.getSelectors((state: RootState) => state.notificationCampaign);
export const campaignSelector = (state: RootState) => state.notificationCampaign;

export const newsDataSelector = createSelector(campaignSelector, campaign => campaign.current.news);

export const fullCampaignSelector = createSelector(campaignSelector, campaign => campaign.current);

export const selectCampaignIsSent = createSelector(campaignSelector, campaign => campaign.current.isSent);

export const smsInfoSelector = createSelector(fullCampaignSelector, full => full.sms);

export const currentNewsSelector = createSelector(fullCampaignSelector, full => full.news);

export const currentCouponSelector = createSelector(fullCampaignSelector, full => full.coupon);

export const currentCampaignSelector = createSelector(fullCampaignSelector, full => full.communicationCampaign);

export const notificationDataSelector = createSelector(
  currentCampaignSelector,
  comCampaign => comCampaign.notification,
);

export const isNewsDifferentFromCampaignSelector = createSelector(
  fullCampaignSelector,
  fullCampaign => fullCampaign.isNewsDifferentFromCampaign,
);

export const campaignFiltersSelector = createSelector(
  fullCampaignSelector,
  fullCampaign => fullCampaign.communicationCampaign.campaignFilters,
);

export const campaignFiltersCrmFieldSelector = (fieldId: string) =>
  createSelector(campaignFiltersSelector, campaignFilters =>
    campaignFilters.crmFieldFilters
      ? campaignFilters.crmFieldFilters.find(filter => filter.fieldId === fieldId)
      : undefined,
  );
export const selectUsers = createSelector(campaignSelector, fullCampaign => fullCampaign.userList);

export const campaignFiltersTypesSelector = createSelector(campaignSelector, campaign => campaign.currentFiltersTypes);

export const hasProfileFilterSelector = createSelector(campaignFiltersTypesSelector, types =>
  types.includes(FilterType.PROFILE),
);
export const hasClientsFilterSelector = createSelector(campaignFiltersTypesSelector, types =>
  types.includes(FilterType.CLIENTS),
);
export const hasCategoryFilterSelector = createSelector(campaignFiltersTypesSelector, types =>
  types.includes(FilterType.CATEGORY),
);

export const campaignDialogSelector = createSelector(campaignSelector, campaign => campaign.campaignValidationDialog);

export const areCampaignsLoadingSelector = createSelector(campaignSelector, campaign => campaign.areCampaignsLoading);
export const hasCampaignsLoadingErrorSelector = createSelector(
  campaignSelector,
  campaign => campaign.hasCampaignsLoadingError,
);

export const isFormCouponVisibleSelector = createSelector(campaignSelector, campaign => campaign.isFormCouponVisible);
export const isFormPostcodeVisibleSelector = createSelector(
  campaignSelector,
  campaign => campaign.isFormPostcodeVisible,
);
export const addressPostcodeSelector = createSelector(campaignSelector, campaign => campaign.addressPostcode);
export const communicationFilterHasErrorFilterSelector = createSelector(
  campaignSelector,
  campaign => campaign.hasErrorFilter,
);
export const warningDialogStateSelector = createSelector(campaignSelector, campaign => campaign.warningDialogState);
export const areAdvancedFiltersValidSelector = createSelector(
  campaignSelector,
  campaign => campaign.areAdvancedFiltersValid,
);

export const selectNotifiedUsers = createSelector(
  campaignSelector,
  campaign => campaign.notifiedUsers.numberOfNotifiedUsers,
);
export const selectNotifiedUsersLoading = createSelector(
  campaignSelector,
  campaign => campaign.notifiedUsers.isNotifiedUsersLoading,
);

export const selectCampaignInfo = createSelector(campaignSelector, campaign => campaign.selected.info);
export const selectCampaignStats = createSelector(campaignSelector, campaign => campaign.selected.stats);
export const selectCampaignCouponClaims = createSelector(campaignSelector, campaign => campaign.selected.couponClaims);
export const selectCampaignCoupon = createSelector(campaignSelector, campaign => campaign.selected.coupon);

export const selectCampaignTemplateDialog = createSelector(
  campaignSelector,
  campaign => campaign.campaignTemplateDialog,
);
export const campaignTemplatesSelector = createSelector(campaignSelector, campaign => campaign.templateList);
